import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { FooterChatDockComponent } from './footer-chat-dock.component';

@Component({
  standalone: true,
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  imports: [CommonModule, FooterChatDockComponent],
})
export class FooterComponent {
  constructor(public router: Router) {}
}
